'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('../text');

var _styled = require('./styled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  return _react2.default.createElement(
    _styled.Btn,
    _extends({}, props, { ref: props.inputRef }),
    props.onlyIcon ? _react2.default.createElement(_icon2.default, { key: 'button-icon', spin: props.spinIcon, icon: props.icon }) : props.loading ? [_react2.default.createElement(_icon2.default, { key: 'button-icon', spin: true, icon: 'fal fa-spinner-third' }), _react2.default.createElement(
      'span',
      { key: 'button-text' },
      props.loadingText ? props.loadingText : props.text ? props.text : 'Button text here'
    )] : props.icon ? props.rightIcon ? [_react2.default.createElement(
      'span',
      { key: 'button-text' },
      props.text ? props.text : 'Button text here'
    ), _react2.default.createElement(_icon2.default, { key: 'button-icon', spin: props.spinIcon, icon: props.icon })] : [_react2.default.createElement(_icon2.default, { key: 'button-icon', spin: props.spinIcon, icon: props.icon }), _react2.default.createElement(
      'span',
      { key: 'button-text' },
      props.text ? props.text : 'Button text here'
    )] : _react2.default.createElement(
      _text.P,
      { key: 'button-text' },
      props.text ? props.text : 'Button text here'
    )
  );
};

Button.propTypes = {
  color: _propTypes.string,
  icon: _propTypes.string,
  text: _propTypes.string,
  inverse: _propTypes.bool,
  fullWidth: _propTypes.bool,
  large: _propTypes.bool,
  small: _propTypes.bool,
  buttonStyle: (0, _propTypes.oneOf)(['round', 'rectangle']),
  ghost: _propTypes.bool,
  rightIcon: _propTypes.bool,
  onlyIcon: _propTypes.bool,
  spinIcon: _propTypes.bool,
  loading: _propTypes.bool,
  loadingText: _propTypes.string,
  width: _propTypes.string,
  inputRef: _propTypes.func
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/konsys-ui/dist/lib/button/index.js
// module id = 331
// module chunks = 0